import * as THREE from 'three'

export const isSingleMaterial = (material: THREE.Material | THREE.Material[]) => material instanceof THREE.Material